module.exports = __webpack_public_path__ + "static/media/xrpl-symbol-black.cc259dd1.svg";